import { render } from "./BranchBindList.vue?vue&type=template&id=a244c824"
import script from "./BranchBindList.vue?vue&type=script&lang=js"
export * from "./BranchBindList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__